import { z, ZodType } from 'zod';
import { Player, playerSchema } from './player';

export type Device = {
	id: number;
	name: string;
	isActive: boolean;
	players: Player[];
};

export const deviceSchema: ZodType<Device> = z.object({
	id: z.number(),
	name: z.string(),
	isActive: z.boolean(),
	players: z.array(playerSchema),
});
